/** Current official timetable release. Previous releases remain archived. */
export const CURRENT_ACADEMIC_TERM = 'Fall 2026';
export const TIMETABLE_EFFECTIVE_DATE = '2026-09-07';
export const ACADEMIC_YEAR = '2026–2027';

export const TIMETABLE_FILES = [
  'BBA_Fall2026.json',
  'BSCS_DataScience_Fall2026.json',
  'English_Fall2026.json',
  'Accounting_Finance_Fall2026.json',
  'BSSE_AI_CyberSecurity_Fall2026.json',
  'Psychology_SocialSciences_Economics_Fall2026.json',
  'Business_Analytics_Fall2026.json',
] as const;
